





















import Vue from "vue";

import iwPropertyPrice from "./questions/price/PropertyPrice.vue";
import iwPricePerSqm from "./questions/price/PricePerSqm.vue";
import iwCadastralIncome from "./questions/price/CadastralIncome.vue";
import iwRequestedMonthlyRentalPrice from "./questions/price/RequestedMonthlyRentalPrice.vue";
import iwMonthlyCharges from "./questions/price/MonthlyCharges.vue";
import iwYearlyRentalPriceSqm from "./questions/price/YearlyRentalPriceSqm.vue";
import iwYearlyRentalPrice from "./questions/price/YearlyRentalPrice.vue";
import iwIsSubjectToVat from "./questions/price/isSubjectToVat.vue";
import iwHasGoodWill from "./questions/price/HasGoodWill.vue";
import iwTenementBuilding from "./questions/price/TenementBuilding.vue";
import iwNextPreviousButton from "@/encoding/components/NextPreviousButton.vue";
import { updateClassified } from "@/shared/scripts/ValidateData";
import { mapActions } from "vuex";
import { pushPageViewEvent } from "@/shared/store/modules/gtm/datalayer";

export default Vue.extend({

    components: {
        iwPropertyPrice: iwPropertyPrice,
        iwPricePerSqm: iwPricePerSqm,
        iwCadastralIncome: iwCadastralIncome,
        iwRequestedMonthlyRentalPrice: iwRequestedMonthlyRentalPrice,
        iwMonthlyCharges: iwMonthlyCharges,
        iwYearlyRentalPrice: iwYearlyRentalPrice,
        iwYearlyRentalPriceSqm: iwYearlyRentalPriceSqm,
        iwIsSubjectToVat: iwIsSubjectToVat,
        iwHasGoodWill: iwHasGoodWill,
        iwTenementBuilding: iwTenementBuilding,
        iwNextPreviousButton: iwNextPreviousButton
    },

    data: function() {
        return {
            isButtonDisabled: false as boolean
        };
    },

    mounted: function() {
        pushPageViewEvent("classified_deposit_step4_price");
    },

    methods: {
        ...mapActions({
            validateAndGoToNextStep: "FormModule/validateAndGoToNextStep",
            goToPreviousStep: "StepsWizard/previous",
            goToNextStep: "StepsWizard/next"
        }),
        clickNext: function(){

            this.isButtonDisabled = true;
            updateClassified(() => {
                Vue.nextTick(() => {
                    const inputsError = document.getElementsByClassName("input--error") as HTMLCollectionOf<HTMLElement>;
                    if (inputsError.length > 0) {
                        inputsError[0].focus();
                        window.scrollTo(0, 0);
                    }
                    this.goToNextStep();
                    this.isButtonDisabled = false;
                });
            });
        },
        clickPrevious: function(){

            this.goToPreviousStep();
        }
    }

});

